import { ProductHeading, Spacing } from '@issuu/silkscreen';
import React from 'react';
const SubHead = props => (React.createElement(Spacing, { bottom: 1, top: 2 },
    React.createElement(ProductHeading, { level: 3, step: "0" }, props.children)));
export default SubHead;
//# sourceMappingURL=SubHead.js.map